import './App.css';
import Logo from './img/logo-white.svg';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Websites from './Websites';
import Applications from './Applications';
import Tutoring from './Tutoring';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import History from './History';
import Aos from 'aos';
import "aos/dist/aos.css";
import react, { Component, useState, useEffect, componentDidMount } from 'react';


class App extends Component {

    componentDidMount() {
      Aos.init({ duration: 700,
        delay:200});
    }


  constructor(props){
    super(props);

    this.state = {
      close:false,
    };
  }

  toggleNav = () => {
    this.setState({
        close: !this.state.close,
    });

    console.log(this.state);
  };



  render(){

    const {close} = this.state;

      return (
      <Router history={History}>
        <div className="app">
          <div className="container"> 
          
          <div className="navbar" data-aos="fade-down">
                <div className="navbar-brand">
                      <Link to={'/'} className="link">
                        <img src={Logo}/>
                      </Link>
                </div>

                
                <div className={close ? "cross" : "burger"} onClick={this.toggleNav} >
                  <div className="line1"/>
                  <div className="line2"/>
                  <div className="line3"/>
                </div>
                  

                  
                <div className={close ? "navbar-links1" : "hidden"} style={{overflowX:'hidden'}}>
                    <div className="navbar-link1">
                      <Link to={'/About'} className="link1" onClick={this.toggleNav}>
                        <p>ABOUT</p> 
                      </Link>
                    </div>
                    <div className="navbar-link1">
                      <Link to={'/Web'} className="link1" onClick={this.toggleNav}>
                          <p>WEB</p> 
                        </Link>
                    </div>
                    <div className="navbar-link1">
                      <Link to={'/App'} className="link1" onClick={this.toggleNav}>
                          <p>APP</p> 
                        </Link>
                    </div>
                    <div className="navbar-link1">
                    <Link to={'/Tutoring'} className="link1" onClick={this.toggleNav}>
                        <p>TUTORING</p> 
                      </Link>
                    </div>
                </div>
            

                <div className="navbar-links">
                    <div className="navbar-link">
                      <Link to={'/About'} className="link">
                        <p>ABOUT</p> 
                      </Link>
                    </div>
                    <div className="navbar-link">
                    <Link to={'/Web'} className="link">
                        <p>WEB</p> 
                      </Link>
                    </div>
                    <div className="navbar-link">
                    <Link to={'/App'} className="link">
                        <p>APP</p> 
                      </Link>
                    </div>
                    <div className="navbar-link">
                    <Link to={'/Tutoring'} className="link">
                        <p>TUTORING</p> 
                      </Link>
                    </div>
                </div>
            </div>

            <Switch>
                <Route exact path='/' component={Home} />
                <Route path='/About' component={About} />
                <Route path='/Web' component={Websites} />
                <Route path='/App' component={Applications} />
                <Route path='/Tutoring' component={Tutoring} />
            </Switch>
      
          </div>
        </div>

      </Router>
    );
  }
}


export default App;
